import styled from "styled-components";

const Hero = styled.div`
  width: 100%;
  padding: 96px 0 96px 0;
  box-sizing: border-box;
  position: relative;
  overflow: visible;

  display: flex;
  justify-content: space-between;
  align-items: center;

  & > * {
    margin-bottom: 40px;
  }

  @media (max-width: 425px) {
    padding-top: 30px;
  }
`;

export default Hero